.event__images {
  display: flex;
  gap: 16px;
  width: 90vw;
  overflow-x: scroll;
}

.event__image {
  height: 150px;
}
